import {mapActions, mapGetters} from 'vuex'
import Multiselect from '@vueform/multiselect'

export default {
    components: {
        Multiselect
    },

    props: ['referenceId', 'referenceType'],

    data() {
        return {
            dataLoaded: false,
            subscribers: []
        }
    },

    computed: {
        ...mapGetters({
            subscribersByReference: 'subscribersByReference',
            users: 'activeUsers'
        }),

        currentSubscribersIds() {
            return this.subscribersByReference(this.referenceType, this.referenceId)
        },

        isDirty() {
            return _.isEqual(this.currentSubscribersIds, _.map(this.subscribers, 'id'))
        }
    },

    watch: {
        users: {
            immediate: true,
            handler() {
                let ids = this.currentSubscribersIds
                this.subscribers = _.filter(this.users, user => ids.includes(user.id))
                this.$nextTick(() => {
                    this.dataLoaded = true
                })
            }
        }
    },

    methods: {
        ...mapActions(['updateSubscribers', 'fetchUsers']),

        handleUpdate() {
            this.updateSubscribers({
                reference_type: this.referenceType,
                reference_id: parseInt(this.referenceId),
                subscribers: _.map(this.subscribers, 'id')
            }).then(() => this.$emit('submitting', false))
        }
    }
}
